import React from 'react';
import PropTypes from 'prop-types';

import { Paragraph } from '@zillow/constellation-10';

import ActionInProgress from './ActionInProgress';
import ActionSelection from './ActionSelection';

const contactActions = {
  call: 'Calling...',
  sms: 'Opening Text Message...',
};

class InquiryContact extends React.Component {
  static propTypes = {
    intentionType: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    phone: PropTypes.string.isRequired,
    onExecuteAction: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.handleResetAction = this.handleResetAction.bind(this);
    this.handleSetAction = this.handleSetAction.bind(this);

    this.didActionOnUpdate = false;
    this.state = {
      inProgress: false,
    };
  }

  componentDidUpdate() {
    const { isMobile, intentionType } = this.props;

    if (isMobile && !this.didActionOnUpdate) {
      this.didActionOnUpdate = true;
      this.setAction(intentionType, false);
    }
  }

  handleResetAction() {
    this.resetAction();
  }

  handleSetAction(intentionType) {
    this.setAction(intentionType);
  }

  setAction(intentionType, sendIntention = true) {
    const { onExecuteAction } = this.props;
    if (!this.state.inProgress) {
      this.setState({
        inProgress: true,
      });
    }
    onExecuteAction(intentionType, sendIntention);
  }

  resetAction() {
    this.setState({
      inProgress: false,
    });
  }

  render() {
    const { intentionType, name, phone } = this.props;

    return (
      <React.Fragment>
        <Paragraph css={{ paddingBottom: '200' }}>Contact</Paragraph>
        <Paragraph textStyle="heading-md" css={{ paddingBottom: '600' }}>
          {name}
        </Paragraph>
        <Paragraph textStyle="heading-xs" css={{ paddingBottom: '600' }}>
          {phone}
        </Paragraph>
        {this.state.inProgress ? (
          <ActionInProgress onResetAction={this.handleResetAction}>{contactActions[intentionType]}</ActionInProgress>
        ) : (
          <ActionSelection onSelectAction={this.handleSetAction} />
        )}
      </React.Fragment>
    );
  }
}

export default InquiryContact;
